import styled from 'styled-components'
import { colors } from '@app/themes'

export const RevealButton = styled.span`
  font-size: 12px;
  padding: 5px;
  background: ${colors.LightGray};
  color: ${colors.NinjaRed};
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;

  &:hover {
    background: ${colors.Silver};
  }
`

export const PhoneNumberContainer = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`
